import apiClient from "@/api/client";
import type { Candidate, CandidateCounts, CandidateFile, CandidateSmsInfo } from "../types";

interface ListResponse {
  data: Candidate[];
  meta: { counts: CandidateCounts };
}

export const recruitmentApi = {
  list: (params?: Record<string, string>) =>
    apiClient
      .get<ListResponse>("/recruitment/candidates/", { params })
      .then((r) => r.data),

  get: (id: string) =>
    apiClient
      .get<{ data: Candidate }>(`/recruitment/candidates/${id}/`)
      .then((r) => r.data.data),

  create: (data: Partial<Candidate>) =>
    apiClient
      .post<{ data: Candidate }>("/recruitment/candidates/", data)
      .then((r) => r.data.data),

  update: (id: string, data: Partial<Candidate>) =>
    apiClient
      .patch<{ data: Candidate }>(`/recruitment/candidates/${id}/`, data)
      .then((r) => r.data.data),

  remove: (id: string) =>
    apiClient.delete(`/recruitment/candidates/${id}/`),

  uploadFile: (candidateId: string, file: File, fileType: string) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("file_type", fileType);
    return apiClient
      .post<{ data: CandidateFile }>(
        `/recruitment/candidates/${candidateId}/upload-file/`,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((r) => r.data.data);
  },

  deleteFile: (candidateId: string, fileId: string) =>
    apiClient.delete(
      `/recruitment/candidates/${candidateId}/delete-file/${fileId}/`
    ),

  todayInterviewsCount: () =>
    apiClient
      .get<{ data: { count: number } }>("/recruitment/candidates/today-interviews-count/")
      .then((r) => r.data.data.count),

  getSmsInfo: (candidateId: string) =>
    apiClient
      .get<{ data: CandidateSmsInfo }>(`/recruitment/candidates/${candidateId}/sms/`)
      .then((r) => r.data.data),

  sendInterviewSms: (candidateId: string, message?: string) =>
    apiClient
      .post<{ data: { sent: boolean; message: string } }>(
        `/recruitment/candidates/${candidateId}/send-interview-sms/`,
        message !== undefined ? { message } : undefined
      )
      .then((r) => r.data.data),
};
